<template>
    <v-container>
        <h4>Seguimientos</h4>
        <v-row>
            <v-col cols="12" md="4">
                <date-select label="Fecha" v-model="seguimiento.fecha">
                </date-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    label="Hora"
                    v-model="seguimiento.hora"
                    v-mask="'##:##'"
                ></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
                <v-checkbox
                    v-model="seguimiento.aviso_email"
                    label="Enviar aviso por email"
                ></v-checkbox>
            </v-col>

            <v-col cols="12">
                <v-autocomplete
                    v-model="seguimiento.seguimiento_users"
                    label="Asignar usuario(s)"
                    :items="users"
                    item-text="name"
                    item-value="id"
                    multiple
                    chips
                    clearable
                    :disabled="role == 5"
                ></v-autocomplete>
            </v-col>

            <v-col cols="12">
                <v-textarea
                    label="Observaciones"
                    v-model="seguimiento.observacion"
                >
                </v-textarea>
            </v-col>

            <v-col cols="12">
                <v-btn @click="SaveSeguimiento" color="success">Guardar</v-btn>
            </v-col>
        </v-row>

        <!---Listado-->
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-data-table
            dense
            :headers="headers"
            :items="Seguimientos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.hora="{ item }">
                <span>{{ formatHora(item.hora) }}</span>
            </template>
            <template v-slot:item.aviso_email="{ item }">
                {{ item.aviso_email ? "Si" : "No" }}
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon
                    @click="editSeguimiento(item)"
                    small
                    class="mr-2"
                    color="#1d2735"
                    style="font-size: 25px"
                    title="EDITAR"
                    >mdi-pencil-outline</v-icon
                >

                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteSeguimiento()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
export default {
    props: ["id"],
    data() {
        return {
            seguimiento: {
                id: null,
                fecha: null,
                observacion: null,
                aviso_email: false,
                seguimiento_users: [],
            },
            search: "",
            headers: [
                {
                    text: "Observaciones",
                    value: "observacion",
                    sortable: false,
                },
                { text: "Fecha", value: "fecha", sortable: false },
                { text: "Hora", value: "hora", sortable: false },
                {
                    text: "Aviso por email",
                    value: "aviso_email",
                    sortable: false,
                },
                { text: "Usuarios", value: "users", sortable: false },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Seguimientos: [],
            selectedItem: 0,
            dialog: false,
            horas: [],
        };
    },
    created() {
        if (this.id) this.getSeguimientos();
        this.$store.dispatch("getUsers");
    },
    watch: {
        id: function (val) {
            if (val) this.getSeguimientos();
        },
        "seguimiento.fecha": function (val) {
            this.generateHoras();
        },
    },
    computed: {
        users() {
            const data = this.$store.getters.getusers;
            return data.users;
        },
        role() {
            return localStorage.getItem("role");
        },
    },
    methods: {
        formatHora(hora) {
            const horaexp = hora.toString().split(".");
            let minutos = 0;
            if (horaexp.length > 1) {
                minutos = parseInt(horaexp[1]) * 0.6;
            }
            return `${horaexp[0].padStart(2, "0")}:${minutos
                .toFixed(0)
                .padStart(2, "0")}`;
        },
        generateHoras() {
            axios
                .get(
                    `api/get-horas-agente/${this.seguimiento.fecha}/${this.id}`
                )
                .then((res) => {
                    this.horas = res.data;
                });
        },
        editSeguimiento(item) {
            this.seguimiento = JSON.parse(JSON.stringify(item));
            this.seguimiento.hora = this.formatHora(this.seguimiento.hora);
        },
        openModal(item) {
            this.selectedItem = this.Seguimientos.indexOf(item);
            this.dialog = true;
        },
        SaveSeguimiento() {
            this.seguimiento.id_cliente = this.id;
            axios.post("api/save-seguimiento", this.seguimiento).then(
                (res) => {
                    this.$toast.sucs("Seguimiento guardado con éxito");
                    this.clearSeguimiento();
                    this.getSeguimientos();
                },
                (err) => {
                    let message = err?.response?.data?.message;
                    if (message.includes("observacion")) {
                        message = message.replace("observacion", "observación");
                    }
                    this.$custom_error(
                        message ?? "Error guardando el seguimiento"
                    );
                }
            );
        },
        deleteSeguimiento() {
            axios
                .post("api/delete-seguimiento", {
                    id: this.Seguimientos[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Seguimiento eliminado con éxito");
                        this.dialog = false;
                        this.getSeguimientos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el seguimiento");
                    }
                );
        },
        getSeguimientos() {
            axios.get(`api/get-seguimiento-cliente/${this.id}`).then(
                (res) => {
                    this.Seguimientos = res.data.seguimientos;
                },
                (err) => {
                    this.$custom_error("Error consultando el seguimiento");
                }
            );
        },
        clearSeguimiento() {
            this.seguimiento = {
                id: null,
                fecha: null,
                observacion: null,
                aviso_email: false,
                seguimiento_users: [],
            };
        },
    },
};
</script>
